import { render, staticRenderFns } from "./c_upload_picture.vue?vue&type=template&id=51ab6ef8&scoped=true"
import script from "./c_upload_picture.vue?vue&type=script&lang=js"
export * from "./c_upload_picture.vue?vue&type=script&lang=js"
import style0 from "./c_upload_picture.vue?vue&type=style&index=0&id=51ab6ef8&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51ab6ef8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\XM\\QD\\yangzhou\\merchant-admin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('51ab6ef8')) {
      api.createRecord('51ab6ef8', component.options)
    } else {
      api.reload('51ab6ef8', component.options)
    }
    module.hot.accept("./c_upload_picture.vue?vue&type=template&id=51ab6ef8&scoped=true", function () {
      api.rerender('51ab6ef8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/maintain/components/mobileFormConfig/c_upload_picture.vue"
export default component.exports